export default __webpack_public_path__ + "static/media/pay respects 2.6e7ae321.png";